<!-- 更多优势 -->
<template>
  <div class="advantage">
    <div class="container">
      <div class="bottom">
        <h1 class="my-title">
          <div>更多迎客优势，</div>
          <strong>值得您的选择</strong>
        </h1>
        <ul>
          <li v-for="item in cardType === 'USLC' ? advantageList : advantageList2" :key="item.id">
            <img :src="item.imgUrl" alt="" />
            <template v-if="item.id !== 5">
              <span>{{ item.name }}</span>
              <strong>{{ item.desc }}</strong>
            </template>
            <template v-else>
              <div class="hidden-sm-and-up">
                <span>{{ item.name }}</span>
                <strong>{{ item.desc }}</strong>
              </div>
              <span class="hidden-xs-only">{{ item.name }}</span>
              <strong class="hidden-xs-only" v-html="item.desc"></strong>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardType: {
      type: String,
      default: 'USLC'
    }
  },
  data() {
    return {
      advantageList: [
        {
          id: 1,
          name: '美国覆盖最广的5G信号',
          desc: '野外露营遇到黑熊也能及时求救',
          imgUrl: require('@/assets/images/portin/advantage1.svg')
        },
        {
          id: 2,
          name: '可开通一卡中美双号',
          desc: '时髦的在美华人， 都需要一个中国手机号， 注册支付宝、银行卡、中国App',
          imgUrl: require('@/assets/images/portin/advantage2.svg')
        },
        {
          id: 3,
          name: '可开通保号服务',
          desc: '超优惠保号服务， 助你丝滑回国过探亲访友',
          imgUrl: require('@/assets/images/portin/advantage3.svg')
        },
        {
          id: 4,
          name: '中美免费邮寄',
          desc: '无论中国还是美国，迎客移动都 免费将sim卡给您派送到家',
          imgUrl: require('@/assets/images/portin/advantage4.svg')
        },
        {
          id: 5,
          name: '7*24小时中英客服',
          desc: '7*24小时的双语客服，母语沟通更便捷，解决问题更高效',
          imgUrl: require('@/assets/images/portin/advantage5.svg')
        }
      ],
      advantageList2: [
        {
          id: 1,
          name: '三免服务',
          desc: '免费三合一手机卡，中美免寄送费，免手续费',
          imgUrl: require('@/assets/images/visa/advantage1.svg')
        },
        {
          id: 2,
          name: '7*24小时中英客服',
          desc: '7*24小时的双语客服， 母语沟通更便捷， 解决问题更高效。',
          imgUrl: require('@/assets/images/visa/advantage2.svg')
        },
        {
          id: 3,
          name: '高速稳定，畅享网络',
          desc: '美国覆盖最广的5G信号，野外露营遇到黑熊也能及时求救稳定，高速的网络信号，让您在全球各地畅享互联网。',
          imgUrl: require('@/assets/images/visa/advantage3.svg')
        },
        {
          id: 4,
          name: '经济实惠',
          desc: '相比于使用国际漫游服务，漫游卡给您提供更加经济实惠的选择，美国手机套餐提供更多流量和通话。',
          imgUrl: require('@/assets/images/visa/advantage4.svg')
        },
        {
          id: 5,
          name: '保护隐私，安全可靠',
          desc: '迎客手机卡采用先进的加密技术，保障您的上网安全。同时，我们严格遵守隐私保护政策，确保您的个人信息得到充分保护。让您在畅游网络世界的同时，安心无忧。',
          imgUrl: require('@/assets/images/visa/advantage5.svg')
        }
      ]
    };
  }
};
</script>
<style scoped lang="less">
@import url(./style/Advantage.less);
</style>
